/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEllipsis2: {
  name: 'ellipsis-2';
  data: string;
} = {
  name: 'ellipsis-2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" fill="currentColor"/></svg>`,
};
